// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1UvDb","paramInput":"JobSimulator_paramInput__ffZz1","input":"JobSimulator_input__33Au1"};